import { useSelector } from "react-redux";

import { ToggleButtons } from "../../../components/ToggleButtons";
import { useModal } from "../../../hooks/useModal";
import { getCollectionPointDetail } from "../../../selectors/collectionPoint";
import { PaymentStatusChangeConfirmationModal } from "../PaymentStatusChangeConfirmationModal";

export const PaymentStatusButton: React.FC = () => {
  const { isPaid } = useSelector(getCollectionPointDetail);
  const { isModalVisible, toggleModalVisibility } = useModal();

  const handleButtonClick = () => {
    toggleModalVisibility();
  };

  return (
    <>
      <ToggleButtons value={isPaid} onChange={handleButtonClick} />
      <PaymentStatusChangeConfirmationModal
        isPaid={!isPaid}
        isModalVisible={isModalVisible}
        toggleModalVisibility={toggleModalVisibility}
      />
    </>
  );
};
